export default "__VITE_ASSET__6ac3e6fb__"